import GameStatesEnum from "../../states/GameStatesEnum";
import Facade from "@/Facade";
import { Signals } from "@/Imports";
import FormatData from "@/application/FormatData";
import Tweenlite from "gsap";
import Platform from "@base/utils/Platform";

export default class UIBehaviors {
  constructor() {
    // Signals.buyFreespinResponse.add(this.disable, this)
    // Signals.setAutoplay.add(this.disable, this)
    // Signals.stopAutoplay.add(this.enable, this)
    // Signals.outroFreespins.add(this.enable, this)
    //

    Signals.balanceUpdate.add(this.sendBalance, this);
    Signals.stateChanged.add(this.onStateChanged, this);
    Signals.setWin.add(this.sendWin, this);

    Signals.outroFreespinsComplete.add(this.onShowFreespinsOutroComplete, this);
    Signals.showBonusOutroComplete.add(this.onShowFreespinsOutroComplete, this);
    Signals.showBonusIntro.add(this.onBonusIntro, this);
    Signals.showBonusIntroComplete.addOnce(
      this.onShowFreespinsIntroComplete,
      this
    );
    Signals.autoplayFinished.add(this.onAutoplayFinished, this);
    Signals.autospinCountChanged.add(this.setAutospinCounter, this);
    Signals.outroFreespinsComplete.add(this.show, this);
    Signals.outroFreespins.add(this.hide, this);
    Signals.showBonusOutroComplete.add(this.show, this);
    Signals.gameInited.add(this.onInited, this);
    Signals.startBonusWinAdding.add(this.onWinsCountupComplete, this);
    Signals.winsCountupComplete.add(this.onWinsCountupComplete, this);
    Signals.showingBigWin.add(this.onShowBigWin, this);
    Signals.showBigWinComplete.add(this.onShowBigWinComplete, this);
    Signals.outroFreespins.add(this.bonusEnd, this);
    Signals.betChanged.add(this.onBetChanged, this);
    Signals.bonusGameComplete.add(this.bonusEnd, this);
    Signals.introFreespins.add(this.onIntroFreeSpins, this);
    // Signals.buyFreespins.add(this.onBuyFreeSpins, this)
    Signals.buyFreespinsNow.add(this.onBuyFreeSpins, this);

    // RelaxSignals.disableAllUI.add(this.disableAllUI, this)
    // RelaxSignals.enableAllUI.add(this.enableAll, this)

    document.addEventListener("UIIsReady", this.onUIIsReady.bind(this));

    this.disableStopForever = false;
    this.sendWin("");

    this.maxBet = false;
    this.minBet = false;

    this.isAutospinShow =
      Facade.model.autospinList.length === 0
        ? false
        : Facade.urlParams.autoSpin;
    this.isMaxBetShow = Facade.urlParams.maxBet;

    let isMute = !Platform.isMobile();

    document.dispatchEvent(
      new CustomEvent("setButtonState", {
        detail: {
          mute: {
            visible: isMute,
            checked: true,
          },
          autospinSettings: {
            visible: this.isAutospinShow,
          },
        },
      })
    );
  }

  onUIIsReady() {
    this.enableAll();
    this.sendBalance(Facade.model.balance);

    let value = FormatData.formatToCoins(Facade.model.totalBet);
    const event = new CustomEvent("ui:setBet", {
      detail: { value: value, currentBetIndex: Facade.model.currentBetIndex },
    });
    document.dispatchEvent(event);
    ///  document.dispatchEvent(new CustomEvent("setLines", { detail: {value: Facade.model.lines.length}}))
    Signals.UIisReady.dispatch();
  }

  bonusEnd() {
    document.dispatchEvent(
      new CustomEvent("setButtonState", {
        detail: {
          showTime: false,
        },
      })
    );
  }

  hide() {
    const event = new CustomEvent("hide", {});
    document.dispatchEvent(event);
    // document.dispatchEvent(new CustomEvent("setButtonState", {detail: {menu: {visible: false}}}))
    this.closeAllPopups();
  }

  show() {
    document.dispatchEvent(
      new CustomEvent("setButtonState", {
        detail: {
          showTime: true,
        },
      })
    );

    this.showUI();
    // if (Facade.model.countAmountFreeBet  > 0) {
    //     const event = new CustomEvent("setFreeSpin", {detail: {value: true}})
    //     document.dispatchEvent(event)
    // }
  }

  showUI() {
    let event = new CustomEvent("show", {});
    document.dispatchEvent(event);
  }

  onShowFreespinsOutroComplete() {
    //        this.sendWin('')
    this.enableAll();
  }

  onInited() {
    if (Facade.model.countAmountFreeBet > 0) {
      const event = new CustomEvent("ui:setFreeSpin", {
        detail: { value: true },
      });
      this.sendWin(Facade.model.winCurrencyFreespins);
      document.dispatchEvent(event);
    }
    this.sendBalance(Facade.model.balance);
  }

  onBuyFreeSpins() {
    document.dispatchEvent(
      new CustomEvent("setBuyFreeSpin", { detail: { value: true } })
    );
    this.sendBalance(Facade.model.balance - Facade.model.totalWin);
  }

  onIntroFreeSpins() {
    if (Facade.model.countAmountFreeBet > 0) {
      const event = new CustomEvent("ui:setFreeSpin", {
        detail: { value: true },
      });
      this.sendWin(Facade.model.winCurrencyFreespins);
      document.dispatchEvent(event);
    }
    this.sendBalance(Facade.model.balance);
  }

  onOutroFreespins() {
    //this.disableAll()
    this.hide();
  }

  onOutroFreespinsComplete() {
    this.show();
  }

  onShowBigWin() {
    this.hide();
  }

  onShowBigWinComplete() {
    if (!Facade.model.isFreespinsMode && !Facade.model.isAuto) {
      this.enableAllCheckDelay();
    }

    this.showUI();
  }

  onShowFreespinsIntroComplete() {
    this.disableAll();
  }

  onStateChanged(state) {
    console.log(
      "UIB   ",
      state,
      Facade.model.isFreespinsMode,
      Facade.model.isBonusStarted
    );
    console.log("ENTRO");
    switch (state) {
      case GameStatesEnum.SHOW_CYCLEWINNINGS:
        if (!Facade.model.isFreespinsMode && !Facade.model.isAuto) {
          this.enableAllCheckDelay();
        } else {
          this.disableAll();

          document.dispatchEvent(
            new CustomEvent("setButtonState", {
              detail: {
                spin: {
                  enable: true,
                },
              },
            })
          );
        }
        this.realityCheckTry();
        break;

      case GameStatesEnum.IDLE:
        // console.log('IDLE   fs', Facade.model.isFreespinsMode, 'fauto ', Facade.model.isAuto, 'bw ',
        // Facade.model.bigWin, Facade.model.isBonusStarted)
        if (
          !Facade.model.isFreespinsMode &&
          !Facade.model.bigWin &&
          !Facade.model.isBonusStarted
        ) {
          this.enableAllCheckDelay();
        }

        this.realityCheckTry();
        break;

      case GameStatesEnum.SPIN_START:
        this.closeAll();

        if (!Facade.model.isFreespinsMode) {
          this.sendWin("");
          Facade.model.totalWinOld = 0;
          if (Facade.model.isAuto) {
            this.disableAllForSpinAuto();
          } else {
            this.disableAllForSpin();
          }
          //this.sendBalance(Facade.model.balance - Facade.model.lineBet * Facade.model.linesPossible.length)
          this.sendBalance(Facade.model.balance - Facade.model.lineBet);
        } else {
          this.disableAll();
          this.setFreespins();
        }
        break;

      case GameStatesEnum.FREE_SPINS_INTRO:
        const e = new CustomEvent("setFreespinsLeft", {
          detail: {
            value: Facade.model.countAmountFreeBet,
            total: Facade.model.freeSpinTotalCount,
          },
        });
        Facade.model.totalWinOld = 0;
        document.dispatchEvent(e);
        this.sendWin("");
        this.disableAll();
        break;

      case GameStatesEnum.GET_BUY_FREESPIN_RESPONSE:
        Facade.model.totalWinOld = 0;
        this.sendWin("");
        this.disableAll();
        break;

      case GameStatesEnum.OUTRO_FREESPINS:
        document.dispatchEvent(
          new CustomEvent("ui:setFreeSpin", { detail: { value: false } })
        );
        this.sendBalance(Facade.model.balance);
        //document.dispatchEvent(new CustomEvent("setTotalWin", {detail: {value: ''}}))

        document.dispatchEvent(
          new CustomEvent("setButtonState", {
            detail: {
              spin: {
                enable: false,
              },
            },
          })
        );
        break;

      case GameStatesEnum.SHOW_BIGWIN:
        this.disableAll();
        break;

      case GameStatesEnum.SHOW_WINNINGS:
        Facade.model.session_total_win += Facade.model.totalWin;
        // if (!Facade.model.isFreespinsMode && !Facade.model.isAuto) { ///  && !Facade.model.bigWin &&!Facade.model.isBonusStarted) {
        //     this.enableAllCheckDelay()
        // } else {
        //     this.disableAll()
        // }

        break;

      case GameStatesEnum.FINAL:
        if (
          !Facade.model.isFreespinsMode &&
          !Facade.model.freeSpinsStart &&
          !Facade.model.bigWin
        ) {
          this.enableAllCheckDelay();
        } else {
          this.disableAll();
        }
        break;
    }
  }

  disableAllForSpin() {
    document.dispatchEvent(
      new CustomEvent("setButtonState", {
        detail: {
          spin: {
            enable: false,
          },
          info: {
            enable: true,
          },
          maxBet: {
            visible: this.isMaxBetShow,
            enable: false,
          },
          plus: {
            enable: false,
          },
          minus: {
            enable: false,
          },
          coinValue: {
            enable: false,
          },
          autoplay: {
            visible: this.isAutospinShow,
            enable: false,
          },
          panelBuyButtons: {
            enable: false,
          },
        },
      })
    );
    Signals.buyButtonDisabled.dispatch();
  }

  disableAllForSpinAuto() {
    document.dispatchEvent(
      new CustomEvent("setButtonState", {
        detail: {
          spin: {
            enable: false,
          },
          info: {
            enable: true,
          },
          maxBet: {
            visible: this.isMaxBetShow,
            enable: false,
          },
          plus: {
            enable: false,
          },
          coinValue: {
            enable: false,
          },
          minus: {
            enable: false,
          },
          autoplay: {
            visible: this.isAutospinShow,
            enable: false,
          },
          autoplayCounter: {
            enable: true,
            visible: true,
          },
          panelBuyButtons: {
            enable: false,
          },
        },
      })
    );
    Signals.buyButtonDisabled.dispatch();
  }

  enableAllCheckDelay() {
    // this.enableAll()
    let enableUIDelayT = UIBehaviors.getEnableUIDelay();
    if (enableUIDelayT > 0) {
      setTimeout(() => {
        this.enableAll();
      }, enableUIDelayT);
    } else {
      this.enableAll();
    }
  }

  enableAll() {
    //BonusGameContainer.showTime("ENABLE_UI")
    console.log("ENABLE ALL");
    document.dispatchEvent(
      new CustomEvent("setButtonState", {
        detail: {
          spin: {
            enable: true,
          },
          info: {
            enable: true,
          },
          maxBet: {
            visible: this.isMaxBetShow,
            enable: true,
          },
          plus: {
            enable: true,
          },
          minus: {
            enable: true,
          },
          autoplay: {
            visible: this.isAutospinShow,
            enable: true,
          },
          autoplayCounter: {
            enable: false,
            visible: false,
          },
          coinValue: {
            visible: true,
            enable: true,
          },
          panelBuyButtons: {
            enable: true,
          },
        },
      })
    );
    Signals.buyButtonEnabled.dispatch();
  }

  disableAllUI() {
    this.disableAll();
    if (Facade.model.isFreeze) {
      if (Facade.model.isAuto) {
        Signals.stopAutoplay.dispatch();
        document.dispatchEvent(
          new CustomEvent("setButtonState", {
            detail: {
              stopAutospin: {
                enable: false,
                visible: false,
              },
            },
          })
        );
      }
      document.dispatchEvent(
        new CustomEvent("setButtonState", {
          detail: {
            spin: {
              enable: false,
            },
          },
        })
      );
    }
  }

  disableAll() {
    document.dispatchEvent(
      new CustomEvent("setButtonState", {
        detail: {
          spin: {
            enable: false,
          },
          info: {
            enable: true,
          },
          maxBet: {
            visible: this.isMaxBetShow,
            enable: false,
          },
          coinValue: {
            enable: false,
          },
          autoplay: {
            visible: this.isAutospinShow,
            enable: false,
          },
          panelBuyButtons: {
            enable: false,
          },
        },
      })
    );
    Signals.buyButtonDisabled.dispatch();
  }

  onBonusIntro() {
    this.disableAll();
    this.hide();
  }

  onWinsCountupComplete(finalWinnings) {
    Facade.model.totalWinOld = finalWinnings;
    if (Facade.model.isFreespinsMode || !finalWinnings) {
      return;
    }
    this.balanceBefore = { val: Facade.model.balance - finalWinnings };
    let balanceAfter = Facade.model.balance;
    Tweenlite.to(this.balanceBefore, 1, {
      val: balanceAfter,
      delay: 1,
      onUpdate: () => {
        Signals.balanceUpdate.dispatch(this.balanceBefore.val, this);
      },
      onComplete: () => {
        Signals.balanceUpdate.dispatch(Facade.model.balance, this);
      },
    });
  }

  onBetChanged(data) {
    const event = new CustomEvent("ui:setBet", {
      detail: {
        value: data.value,
        currentBetIndex: Facade.model.currentBetIndex,
      },
    });
    document.dispatchEvent(event);

    const event1 = new CustomEvent("setBetPerLine", {
      detail: { value: Facade.model.currentBetIndex },
    });
    document.dispatchEvent(event1);
  }

  sendBalance(value) {
    if (value < 0) {
      return;
    }
    const balanceEvent = new CustomEvent("ui:setBalance", {
      detail: { value: FormatData.formatToCoins(value) },
    });
    document.dispatchEvent(balanceEvent);
  }

  sendWin(value) {
    const winEvent = new CustomEvent("ui:setWin", {
      detail: { value: FormatData.formatToCoins(value) },
    });
    document.dispatchEvent(winEvent);
  }

  setFreespins() {
    //   if (Facade.model.countAmountFreeBet) {
    let amountLeft = Facade.model.countAmountFreeBet;
    const event = new CustomEvent("setFreespinsLeft", {
      detail: {
        value: amountLeft - 1,
        total: Facade.model.freeSpinTotalCount, //freespins.total_amount_given //bonus.freebetGiven
      },
    });
    document.dispatchEvent(event);
    if (Facade.model.freespins.triggered_win_bonus_amount_currency) {
      /// amount += Facade.model.freespins.triggered_win_bonus_amount_currency
    }
    document.dispatchEvent(
      new CustomEvent("setTotalWin", {
        detail: {
          value: FormatData.formatToCoins(Facade.model.winCurrencyFreespins),
        },
      })
    );
    Signals.buyButtonDisabled.dispatch();
    //   }
  }

  closeAll() {
    document.dispatchEvent(new CustomEvent("close", { detail: {} }));
  }

  closeAllPopups() {
    document.dispatchEvent(
      new CustomEvent("close", { detail: { name: "menu" } })
    );
    document.dispatchEvent(
      new CustomEvent("close", { detail: { name: "autoplay" } })
    );
    document.dispatchEvent(
      new CustomEvent("close", { detail: { name: "info" } })
    );
    document.dispatchEvent(
      new CustomEvent("close", { detail: { name: "paytable" } })
    );
    document.dispatchEvent(
      new CustomEvent("close", { detail: { name: "coinValue" } })
    );
    document.dispatchEvent(
      new CustomEvent("close", { detail: { name: "settings" } })
    );
  }

  setAutospinCounter(value) {
    document.dispatchEvent(
      new CustomEvent("setButtonState", {
        detail: {
          spin: {
            enable: false,
          },
          autoplayCounter: {
            enable: true,
            visible: true,
          },
        },
      })
    );
    document.dispatchEvent(
      new CustomEvent("setAutospinValue", { detail: { value: value } })
    );
  }

  onAutoplayFinished() {
    document.dispatchEvent(
      new CustomEvent("setButtonState", {
        detail: {
          spin: {
            visible: true,
          },
          autoplayCounter: {
            enable: false,
            visible: false,
          },
        },
      })
    );
    document.dispatchEvent(new CustomEvent("setAutospinStop"));
  }

  realityCheckTry() {
    if (Facade.urlParams.realityCheckTime) {
      if (!this.realityCheckTimeout) {
        this.realityCheckTimeout = setTimeout(() => {
          this.realityCheckTimeout = null;
          Signals.realityCheck2.dispatch();
        }, Facade.urlParams.realityCheckTime * 1000);
      }
    }
  }

  static getEnableUIDelay() {
    return !Facade.model.lastSpinTime
      ? 0
      : Math.max(
          0,
          Facade.model.minIntervalSpin -
            (new Date().getTime() - Facade.model.lastSpinTime.getTime())
        );
  }
}
